export default "__VITE_ASSET__BzQniUMx__"